import React from "react"
import { Col, Modal } from "react-bootstrap";

import { Common } from "../../../helper";
import { FillColor, SpecifyName } from "../";

const CommonModal = (props) => {
  const { showModal, value, setShowModal } = props;
  
  const handleCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <Modal show={showModal} className="comment-modalOne" onHide={handleCloseModal} backdrop="static" keyboard={false}>
        <Modal.Header className="viewSchoolHeader" closeButton>
          <Col> <span className="d-flex justify-content-center align-items-center topic" >{Common.Pupils}</span></Col>
        </Modal.Header>
        <Modal.Body className="addEvidenceModalBody">
          {
            value?.map((item,index) => {
              return(<div key={index} className="mainDiv">
                <div className="titleDiv"><div className="pointer" style={{ background: FillColor(item.name) }}></div>&nbsp;<span className="title">{`${SpecifyName(item.name)} (${item.value})`}</span></div>
                {item.pupil.length>0?<>
                  {item.pupil.map((pupils)=>(<><span className="text">{`${pupils.firstName} ${pupils.lastName}`}</span><br/></>))}
                </>:<span>{Common.NoPupils}</span>}
              </div>)
            })
          }
        </Modal.Body>
        <Modal.Footer className="comment-modal-footer">
          <button className="upload-cancel" type="button" onClick={handleCloseModal}>{Common.Close}</button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export { CommonModal }